import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import ImagesImportContainer from "../../../components/ImagesImportContainer/ImagesImportContainer";
import Input from "../../../components/Input/Input";
import ModalComponent from "../../../components/Modal/ModalComponent";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { useListManager } from "../../../contexts/list.manager";
import { useUserStore } from "../../../contexts/userStore";
import removeMask from "../../../functions/RemoveMask";
import AccessGroupService from "../../../services/AccessGroupService";
import CondoUserService from "../../../services/CondoUserService";
import ImagesService from "../../../services/ImagesService";
import TabCondoUsersAccessGroups from "../TabsCondoUsers/TabAccessGroups/TabCondoUsersAccessGroups";
import TabCondoUserCredentials from "../TabsCondoUsers/TabCredentials/TabCondoUsersCredentials";
import TabCondoUsersFingerprints from "../TabsCondoUsers/TabFingerprints/TabCondoUsersFingerprints";
import TabCondoUserUnits from "../TabsCondoUsers/TabUnits/TabCondoUsersUnits";
import TabCondoUsersVehicles from "../TabsCondoUsers/TabVehicles/TabCondoUsersVehicles";
import "./FormCondoUsers.css";
import { useAuth } from "../../../contexts/auth";
import { LuUser } from "react-icons/lu";
import { slugify } from "../../../utils/string";
import { AnimatedTabbar, AnimatedTabbarItem } from "../../../components/AnimatedTabbar/AnimatedTabbar";
import { Building2, Car, Fingerprint, Key, Users } from "lucide-react";

function FormCondoUsers(props) {
	const { user } = useAuth();
	const [name, setName] = useState(props.condoUser?.name);
	const [enabled, setEnabled] = useState(props.condoUser?.enabled);
	const [cpf, setCpf] = useState(props.condoUser?.cpf || "");
	const [rg, setRg] = useState(props.condoUser?.rg);
	const [mail, setMail] = useState(props.condoUser?.mail);
	const [phoneNumber, setPhoneNumber] = useState(props.condoUser?.phone_number);
	const [description, setDescription] = useState(
		props.condoUser?.description
	);
	const [isAdmin, setIsAdmin] = useState(props.condoUser?.isAdmin);
	const [urlImg, setUrlImg] = useState(props.condoUser?.url_photo);
	const [groups, setGroups] = useState(props.condoUser?.groups);
	const [idUnit, setIdUnit] = useState(props.condoUser?.id_unit);
	const [credentials, setCredentials] = useState(props.condoUser?.credentials);
	const [condoUserLicenses, setCondoUserLicenses] = useState([]);
	const [tags, setTags] = useState([]);
	const [vehicles, setVehicles] = useState(props.condoUser?.vehicles);
	const [fingerprints, setFingerprints] = useState(
		props.condoUser?.fingerprints
	);
	const [uuid, setUuid] = useState(props.condoUser?.uuid);
	// Estado do checkbox e do grupo temporário — vivem aqui para sobreviver à troca de abas
	const [isTempUser, setIsTempUser] = useState(() => {
		const g = props.condoUser?.groups;
		return Array.isArray(g) && g.length > 0 && g.find(g => g.isTempEnabled === true);
	});
	const [tempGroup, setTempGroup] = useState(() => {
		const g = props.condoUser?.groups;
		return Array.isArray(g) && g.length > 0 && g.find(g => g.isTempEnabled === true)
			? g.find(g => g.isTempEnabled === true)
			: null;
	});
	const navigate = useNavigate();
	const { selectedCondominio, selectedLicenceObj } = useUserStore();
	const { closeForm } = useListManager();
	const [tabContent, setTabContent] = useState(3);
	const [photoFile, setPhotoFile] = useState();
	const [licensesIsLoading, setLicensesIsLoading] = useState(true);
	const [licensesWithoutReaders, setLicensesWithoutReaders] = useState([]);
	const [showReadersWarning, setShowReadersWarning] = useState(false);

	useEffect(() => {
		setLicensesIsLoading(!!props.condoUser?.name);
		setName(props.condoUser?.name);
		setEnabled(props.condoUser?.enabled || false);
		setUrlImg(props.condoUser?.url_photo);
		setGroups(props.condoUser?.groups);
		setIdUnit(props.condoUser?.id_unit);
		setCredentials(props.condoUser?.credentials?.map(credential => ({
			...credential,
			licenses: credential.licenses ?? credential.licenseIds?.map(id => ({ id })) ?? [],
		})) ?? []);
		setVehicles(props.condoUser?.vehicles?.map(vehicle => ({
			...vehicle,
			licenses: vehicle.licenses ?? vehicle.licenseIds?.map(id => ({ id })) ?? [],
		})));
		setFingerprints(props.condoUser?.fingerprints);
		setCpf(props.condoUser?.cpf);
		setRg(props.condoUser?.rg);
		setMail(props.condoUser?.mail);
		setPhoneNumber(props.condoUser?.phone_number);
		setDescription(props.condoUser?.description);
		setUuid(props.condoUser?.uuid);
		const g = props.condoUser?.groups;
		const hasTempGroup = Array.isArray(g) && g.length > 0 && g.find(g => g.isTempEnabled === true);
		if (hasTempGroup) {
			(async () => {
				const response = await AccessGroupService.getOneUuid(g.find(g => g.isTempEnabled === true).uuid);
				if (response.status === 200) {
					setTempGroup(response.data);
				}
			})();
		} else {
			setTempGroup(null);
		}
		setIsTempUser(hasTempGroup);
	}, [props.condoUser]);

	const buildPayload = (urlFromResponse) => {
		console.log('condoUserLicenses', condoUserLicenses);
		let payload = {
			id_condominium: selectedCondominio,
			groups: groups?.filter(g => (!isTempUser && !g.isTempEnabled) || (isTempUser && tempGroup?.useAccessGroupsEnabled) || (isTempUser && g.isTempEnabled)),
			credentials: credentials,
			vehicles: vehicles,
			url_photo: urlFromResponse,
			name: name,
			enabled: enabled,
			cpf: cpf ? removeMask(cpf) : null,
			rg: rg ? removeMask(rg) : null,
			mail: mail,
			phone_number: phoneNumber,
			description: description,
			uuid: !uuid ? uuidv4() : uuid,
			fingerprints: fingerprints?.filter(f => f),
			tags: tags,
			licenses: condoUserLicenses.map(cl => {
				return {
					id: cl.id ?? null,
					uuid: cl.uuid,
					licenseId: cl.license.id,
					isAdmin: cl.isAdmin,
					enrollment_number: cl.enrollment_number,
					ownerUnitId: cl.ownerUnit?.id,
					unitId: cl.unit?.id,
					responsibility: cl.responsibility,
					relation: cl.relation,
					otherRelation: cl.otherRelation,
					authorizerUnits: cl.authorizerUnits?.map(u => u.uuid),
					credits: cl.credits,
					disabledCredits: cl.disabledCredits,
					readersUuids: cl.readers?.filter(r => r.status !== 'deleting').map(r => r.reader?.uuid),
					readersToDeleteUuids: cl.readers?.filter(r => r.status === 'deleting').map(r => r.reader?.uuid),
				}
			}),
		};
		return payload;
	};

	async function handleImportPhotoSubmission() {
		let newUrl = urlImg;

		if (photoFile != null) {
			const now = new Date();
			const date = format(now, "yyyyMMddHHmmss");
			newUrl = `device-images/${selectedLicenceObj?.SN_equipment}/${date}_${slugify(name)}/${slugify(name)}.jpeg`;
			const formData = new FormData();
			formData.append("file", photoFile);
			formData.append("imageUrl", newUrl);
			formData.append("entity", "user");
			formData.append("organizationExternalId", user.userData.selectedOrganization.externalId);
			formData.append("serialNumber", selectedLicenceObj?.SN_equipment);
			const response = await ImagesService.storeImage(formData);
			setUrlImg(response.data.payload.id);
			return response.data.payload.id;
		} else {
			return newUrl;
		}
	}

	async function handleSubmit(event, confirmedMissingReaders = false) {
		if (licensesIsLoading) {
			NotificationManager.warning("Aguarde o carregamento das licenças", "Atenção", 5000);
			return;
		}
		if (event) {
			event.preventDefault();
		}
		if (!name) {
			NotificationManager.warning("Preencha o nome", "Atenção", 5000);
			return;
		}
		if (!groups || groups.length === 0) {
			NotificationManager.warning(
				"Preencha ao menos um grupo de acesso",
				"Atenção",
				5000
			);
			return;
		}
		if (!confirmedMissingReaders) {
			if (condoUserLicenses.some(cl => cl.id && cl.readers == null)) {
				NotificationManager.warning("Aguarde o carregamento das leitoras", "Atenção", 5000);
				return;
			}

			const missingReaders = condoUserLicenses.filter(cl =>
				!cl.readers?.some(reader => reader.status !== "deleting")
			);
			if (missingReaders.length > 0) {
				setLicensesWithoutReaders(missingReaders);
				setShowReadersWarning(true);
				return;
			}
		}
		const urlFromResponse = await handleImportPhotoSubmission();
		let payload = buildPayload(urlFromResponse);
		let responseTempGroup = null;
		const tempGroup = payload.groups?.find(g => g.isTempEnabled);
		if (payload.groups?.length > 0 && tempGroup) {
			const otherGroups = payload.groups?.filter(g => !g.isTempEnabled);
			if (tempGroup.id) {
				responseTempGroup = await AccessGroupService.updateAccessGroup(
					tempGroup.id,
					{
						...tempGroup,
						groupUuids: tempGroup.useAccessGroupsEnabled ? otherGroups?.map(g => g.uuid) : null,
					}
				);
			} else {
				responseTempGroup = await AccessGroupService.createAccessGroup(
					{
						...tempGroup,
						groupUuids: tempGroup.useAccessGroupsEnabled ? otherGroups?.map(g => g.uuid) : null,
					}
				);
			}
			if (![200, 201].includes(responseTempGroup.status)) {
				NotificationManager.error(`Erro ao ${tempGroup.id ? 'atualizar' : 'cadastrar'} acesso temporário`, "Erro", 5000);
				return;
			}
			payload.groups = [
				...otherGroups,
				responseTempGroup.data,
			];
		}

		let response = null;
		if (props.type === "edicao") {
			response = await CondoUserService.updateCondoUser(
				props.condoUser?.id,
				payload
			);
		}
		if (props.type === "cadastro") {
			response = await CondoUserService.createCondoUser(payload);
		}
		if (response.data.id) {
			navigate("../consulta-condo-users", {
				state: { refresh: true }
			});
			closeForm();
		}
	}

	function getReadersWarningText() {
		const licenseNames = licensesWithoutReaders.map(cl =>
			cl.license?.name ?? cl.license?.id
		);
		const licenseList = licenseNames.length < 2
			? licenseNames[0]
			: `${licenseNames.slice(0, -1).join(", ")} e ${licenseNames[licenseNames.length - 1]}`;
		const isPlural = licenseNames.length > 1;

		return `${isPlural ? "As licenças" : "A licença"} ${licenseList} ${isPlural ? "não possuem" : "não possui"
			} leitoras vinculadas para o usuário. Se o usuário já possuir vínculo nas leitoras, será apagado!`;
	}

	async function handleDelete() {
		if (!props.condoUser) return;
		await CondoUserService.deleteCondoUser(props.condoUser.id);
		navigate("../consulta-condo-users", {
			state: { deletedId: props.condoUser.id },
		});
		closeForm();
	}

	const handleClickEditButton = () => {
		if (!props.condoUser) return;
		navigate(`/device-users/${props.condoUser.uuid}`, { state: props.condoUser });
	};

	function handleChangeGroups(groups) {
		setGroups(groups);
	}

	// Atualiza tempGroup (preserva estado UI entre abas) e groups (usado no submit)
	function handleTempGroupChange(tempGrp) {
		setTempGroup(tempGrp);
		setGroups(prevGroups => {
			const selectedGroups = (prevGroups ?? []).filter(g => !g.isTempEnabled);
			return tempGrp ? [...selectedGroups, tempGrp] : selectedGroups;
		});
	}

	async function handleChangeVehicles(vehicles) {
		setVehicles(vehicles.map(v => {
			const vehicle = { ...v };
			if (!v.credential) {
				delete vehicle.credential;
			}
			return vehicle;
		}));
	}

	async function handleChangeLicenses(licenses) {
		setCondoUserLicenses(licenses);
	}

	async function handleChangeTags(tags) {
		setTags(tags);
	}

	async function handleChangeCredentials(credentials) {
		setCredentials(credentials);
	}

	async function handleChangeFingerprints(fingerprints) {
		setFingerprints(fingerprints);
	}

	return (
		<div className={`form-person ${props.type === 'consulta' ? 'form-person-consulta' : ''}`}>
			<FormTitle
				urlLogo={urlImg}
				icon={<LuUser size={20} />}
				type={props.type}
				tituloConsulta={props.condoUser?.name || null}
				tituloCadastro="Cadastro de Usuário"
				backRoute={"/consulta-condo-users"}
			/>
			<Form
				handleSubmit={handleSubmit}
				type={props.type}
				handleClickEdit={handleClickEditButton}
				handleDelete={handleDelete}
				navigateCancelUrl="../consulta-condo-users"
				deleteButNotSynqed={props.condoUser?.deletedAt ? true : false}
				saveDisabled={licensesIsLoading}
			// aditionalButtonCadastro={
			// 	<OpenDoorButton
			// 		label={"Salvar e Abrir Porta"}
			// 		hideUserSelection={true}
			// 		onConfirmOpenDoor={() => handleSubmit()}
			// 		modalText="Selecione um ponto de acesso para ser liberado"
			// 	/>
			// }
			>
				<div className={`form-container ${props.type === 'consulta' ? 'mt-7!' : 'mt-7!'} px-0! gap-6!`}>
					<div className="container-form-image">
						{props.type !== "consulta" && (
							<ImagesImportContainer
								setUrlImg={(url) => setUrlImg(url)}
								onFileChanged={(file) => setPhotoFile(file)}
								urlImg={urlImg}
								onlyImage={true}
							/>
						)}
					</div>
					<div className="container-form-inputs">
						<div className="form-inputs-name">
							<Input
								name="name"
								id="name"
								labelText="Nome *"
								value={name}
								onChange={({ target }) => {
									const newValue = target.value.replace(/[0-9]/g, "");
									setName(newValue);
								}}
								tooltipText="Nome do usuário do condomínio."
								tooltipVisible={true}
								disabled={props.type === "consulta"}
								required={false}
							/>
							<Input
								name={"cpf"}
								id="cpf"
								labelText={"CPF"}
								value={cpf}
								onChange={({ target }) => setCpf(target.value)}
								disabled={props.type === "consulta"}
								minLength={"14"}
								maxLength={"14"}
								showCpfCnpjMask={true}
								showCpfMask={true}
								placeholder="000.000.000-00"
								tooltipText="CPF do usuário do condomínio."
								tooltipVisible={true}
							/>
						</div>
						<div className="form-inputs-name">
							<Input
								name="rg"
								id="rg"
								labelText="RG"
								value={rg}
								onChange={({ target }) => setRg(target.value)}
								disabled={props.type === "consulta"}
								required={false}
								tooltipText="RG do usuário do condomínio."
								tooltipVisible={true}
								showRgMask={true}
							/>
							{props.type !== "consulta" && (
								<Input
									name="description"
									id="description"
									labelText="Observações"
									value={description}
									onChange={({ target }) =>
										setDescription(target.value)
									}
									disabled={props.type === "consulta"}
									required={false}
									tooltipText="Observações sobre o usuário do condomínio."
									tooltipVisible={true}
								/>
							)}
						</div>
						<div className="form-inputs-mail-phone">
							<Input
								name="mail"
								id="mail"
								labelText="E-mail"
								value={mail}
								onChange={({ target }) => setMail(target.value)}
								disabled={props.type === "consulta"}
								required={false}
								placeholder="exemplo@email.com"
								tooltipText="E-mail do usuário do condomínio."
								tooltipVisible={true}
							/>
							<Input
								name={"phone_number"}
								id="phone_number"
								labelText="Telefone"
								value={phoneNumber}
								onChange={({ target }) => setPhoneNumber(target.value)}
								disabled={props.type === "consulta"}
								required={false}
								placeholder="(00) 00000-0000"
								showPhoneMask={true}
								minLength={"15"}
								maxLength={"15"}
								tooltipText="Telefone do usuário do condomínio."
								tooltipVisible={true}
							/>
						</div>
						<div
							className="form-checkbox"
							style={{
								flexDirection: props.type === "consulta" ? "column" : "row",
								marginTop: "10px"
							}}
						>
							<ToggleButton
								label="Habilitado"
								selected={enabled}
								onChange={({ target }) => setEnabled(target.checked)}
								required={false}
								disabled={props.type === "consulta"}
								tooltipText={
									"Habilita ou desabilita o usuário."
								}
								tooltipVisible={true}
							/>
						</div>
					</div>
				</div>

				{props.type !== "consulta" && (
					<>
						<AnimatedTabbar
							value={tabContent}
							className={`my-3!`}
							classNameList={`justify-center!`}
							onChange={value => setTabContent(Number(value))}
						>
							<AnimatedTabbarItem name={3}>
								<span><Building2 size={17} /></span>
								<span>Licenças</span>
							</AnimatedTabbarItem>
							<AnimatedTabbarItem name={4}>
								<span><Key size={16} /></span>
								<span>Credenciais</span>
							</AnimatedTabbarItem>
							<AnimatedTabbarItem name={6}>
								<span><Fingerprint size={16} /></span>
								<span>Digitais</span>
							</AnimatedTabbarItem>
							<AnimatedTabbarItem name={5}>
								<span><Car size={17} /></span>
								<span>Veículos</span>
							</AnimatedTabbarItem>
							<AnimatedTabbarItem name={2}>
								<span><Users size={16} /></span>
								<span>Grupos de Acesso</span>
							</AnimatedTabbarItem>
						</AnimatedTabbar>

						<div className="tabs-content tabs-condo-user" style={{ width: "100%" }}>
							{tabContent === 1 && (
								<div></div>
							)}
							<TabCondoUsersAccessGroups
								className={`${tabContent === 2 ? '' : 'hidden!'}`}
								condoUser={props.condoUser}
								groups={groups}
								handleChangeGroups={handleChangeGroups}
								tabChanged={tabContent}
								isTempUser={isTempUser}
								onIsTempUserChange={setIsTempUser}
								tempGroup={tempGroup}
								onTempGroupChange={handleTempGroupChange}
							/>
							<TabCondoUserUnits
								show={tabContent === 3}
								condoUser={props.condoUser}
								idUnit={idUnit}
								handleChangeLicenses={handleChangeLicenses}
								handleChangeTags={handleChangeTags}
								licenseIsLoading={licensesIsLoading}
								setLicensesIsLoading={setLicensesIsLoading}
							/>
							{tabContent === 4 && (
								<TabCondoUserCredentials
									show={tabContent === 4}
									condoUser={props.condoUser}
									condoUserLicenses={condoUserLicenses}
									credentials={credentials}
									handleChangeCredentials={handleChangeCredentials}
								/>
							)}
							{tabContent === 6 && (
								<TabCondoUsersFingerprints
									condoUser={props.condoUser}
									fingerprints={fingerprints ?? []}
									handleChangeFingerprints={handleChangeFingerprints}
								/>
							)}
							{tabContent === 5 && (
								<TabCondoUsersVehicles
									condoUser={props.condoUser}
									condoUserLicenses={condoUserLicenses}
									credentials={credentials}
									vehicles={vehicles}
									handleChangeVehicles={handleChangeVehicles}
								/>
							)}
						</div>
					</>
				)}
			</Form>
			<ModalComponent
				modalIsOpen={showReadersWarning}
				modalText={getReadersWarningText()}
				buttonLabel1="Confirmar"
				buttonLabel2="Cancelar"
				handleConfirm={() => {
					setShowReadersWarning(false);
					handleSubmit(null, true);
				}}
				handleCancel={() => setShowReadersWarning(false)}
			/>
		</div>
	);
}

export default FormCondoUsers;
